import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { showCustomToast } from '../components/common/CustomToast';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const ReferralHandler: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isConnected, token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const handleReferral = async () => {
      const ref = searchParams.get('ref');
      
      // Only process if user is logged in and there's a referral code
      if (!ref || !isConnected || !token) return;

      try {
        const response = await fetch(`${API_BASE_URL}/api/affiliate/claim`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ code: ref })
        });

        const data = await response.json();

        if (response.ok) {
          showCustomToast.success(`You are now supporting ${ref}!`, 4000);
          
          // Remove ref parameter from URL
          searchParams.delete('ref');
          setSearchParams(searchParams);
          
          // Navigate to settings affiliate tab
          setTimeout(() => {
            navigate('/settings?tab=affiliates');
          }, 1500);
        } else {
          // If error is "already claimed", silently remove the ref param
          if (data.error?.includes('already claimed')) {
            searchParams.delete('ref');
            setSearchParams(searchParams);
          }
          // Don't show error toast for other cases (invalid code, own code, etc.)
          // Just remove the ref param
          searchParams.delete('ref');
          setSearchParams(searchParams);
        }
      } catch (error) {
        // Silently remove ref param on error
        searchParams.delete('ref');
        setSearchParams(searchParams);
      }
    };

    handleReferral();
  }, [searchParams, isConnected, token, navigate, setSearchParams]);

  return null;
};
